import React, {forwardRef, useImperativeHandle, useState} from "react";
import {message, Modal, Spin} from "antd";
import {IconClose, IconLoadingIndicator} from "../../Icon";
import {hasLicense, imgPathPerfix, isStringNullOrEmpty} from "../../utils";
import {ipcSend} from "../../common/ipc";
import {t} from "i18next";
import {LoadingOutlined} from "@ant-design/icons";
import {detectText} from "../../api/GoogleApi";
import clipboard from "clipboardy";

const DialogOcrResult = forwardRef((props, ref)=>{
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }))

    const [isShowDialog,setIsShowDialog] = useState(false);
    const [isShowLoading,setIsShowLoading] = useState(false);
    const [recognizedResult,setRecognizedResult] = useState(' ');

    const onShowDialog = (szBase64:string)=>{
        setIsShowDialog(true);
        setIsShowLoading(true);
        setRecognizedResult(' ');
        detectText(szBase64).then(res=>{
            setIsShowLoading(false);
            if (res){
                setRecognizedResult(res)
            }else{
                setRecognizedResult('');
            }
        })
    }

    return(
        <Modal centered={true} open={isShowDialog} closable={true} closeIcon={<IconClose/>} footer={''}
               onCancel={(e) => {
                   setIsShowDialog(false);
               }} width='468px' bodyStyle={{margin:'-24px -20px'}}>
            <div className='font-size-12' style={{
                display: 'flex',
                padding: '20px 20px 10px 20px',
                flexDirection: 'column',
                position:'relative'
            }}>
                <div className='flex-row-vertical-center'>
                    <span className='dialog-title'>{t("OCR")}</span>
                    {/*<img className='img-18 ml-6' src={imgPathPerfix() + 'vip.png'}/>*/}
                </div>

                <div className='line' style={{margin: '12px -16px'}}></div>

                {
                    !isShowLoading && isStringNullOrEmpty(recognizedResult) &&
                    <span
                        style={{
                            color: '#666666',
                            marginTop: '1px',
                            lineHeight: '24px'
                        }}>{t("NoTextCouldBeRecognized")}</span>
                }

                {
                    recognizedResult &&
                    <textarea value={recognizedResult} style={{
                        width: '428px',
                        height: '354px',
                        background: 'var(--textarea-background-color)',
                        borderRadius: '8px',
                        outline: "none",
                        resize: 'none',
                        border: 'none',
                        color:'var(--text-color)',
                        padding:'12px',
                        fontSize:'12px'
                    }} onChange={(e)=>setRecognizedResult(e.currentTarget.value)}/>
                }


                {
                    isShowLoading &&
                    <div style={{position:"absolute",left:'50%',top:'50%',transform:'translateX(-50%) translateY(-50%)'}}>
                        <IconLoadingIndicator/>
                    </div>

                }

                {
                    !isShowLoading && recognizedResult &&
                    <div className='flex-center button-solid-style'
                         style={{width: '164px', height: '38px', marginTop: '20px', alignSelf: 'center'}}
                         onClick={() => {
                             clipboard.write(recognizedResult);
                             message.info(t("Has copyed"));
                             setIsShowDialog(false);
                         }}>
                        <span className='ml-6 font-family-medium'>{t("Copy to clipboard")}</span>
                    </div>
                }


            </div>
        </Modal>
    )
})

export default React.memo(DialogOcrResult);